import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Segment’s Customer Data Maturity Model Methodology`,
  descriptions: [
    `You can only create exceptional customer experiences by investing in your customer data infrastructure. Companies that use customer data effectively can deliver better experiences, make better decisions, and more easily achieve their growth goals.`,
    `To help you understand your strengths and weaknesses when it comes to data maturity, we use these four core competencies:`,
  ],
}

const Methodology = () => (
  <StyledSection variant="centered">
    <Section.Copy>
      <CopyTextBase centered={true}>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        {copy.descriptions.map((description, i) => (
          <StyledDescription key={i}>{description}</StyledDescription>
        ))}
      </CopyTextBase>
    </Section.Copy>
  </StyledSection>
)

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`

const StyledDescription = styled(CopyText.Description)`
  padding-top: 14px;
`

export default Methodology
